import React, { useState, useEffect } from "react";
import { isEmpty } from "lodash";
import { Modal, Table } from "antd";
import Cookies from "universal-cookie";
import ReportTable from "../../componentsShared/ReportTable";
import ReportTableHeader from "../../componentsShared/ReportTableHeader";
import ViewAllButton from "../../componentsShared/ViewAllButton";
import { BACKEND_URL, CUSTOM_FILTER_KEYS } from "../../constants/constants";
import "./style.scss";

const cookies = new Cookies();

const columns = [
  {
    title: "Merchandiser",
    dataIndex: "merchandiser",
    width: "33.33%",
    key: "merchandiser",
    sorter: (a, b) => a.merchandiser.localeCompare(b.merchandiser),
    showSorterTooltip: false,
  },
  {
    title: "Store",
    dataIndex: "stores",
    width: "33.33%",
    align: "left",
    key: "stores",
    render: (stores) => (
      <>
        {stores &&
          stores.map((storeData, index) => {
            return <div key={index}>{storeData.store}</div>;
          })}
      </>
    ),
  },
  {
    title: "Planogram Compliance Score (%)",
    dataIndex: "stores",
    key: "stores",
    align: "center",
    width: "33.33%",
    showSorterTooltip: false,
    sorter: (a, b) =>
      Number(a.stores[0].planogram) - Number(b.stores[0].planogram),
    render: (stores) => (
      <>
        {stores &&
          stores.map((storeData, index) => {
            return <div key={index}>{storeData.planogram}%</div>;
          })}
      </>
    ),
  },
];

const auditData = [
  /*{
        auditor: 'Sally',
        store: 'Store A',
        overdueBy: 5,
    },
    {
        auditor: 'John',
        store: 'Store B',
        overdueBy: 4,
    },
    {
        auditor: 'Adrian',
        store: 'Store C',
        overdueBy: 3,
    },
    {
        auditor: 'Gary',
        store: 'Store D',
        overdueBy: 2,
    },*/
];

const NoOfNonCompliantStoresByAccount = (props) => {
  const [data, setData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [tableConfigs, setTableConfigs] = useState([]);

  // const fetchBaseKpi = () => {
  //   if (
  //     cookies.get("store") &&
  //     cookies.get("store") !== "" &&
  //     cookies.get("store") !== "undefined"
  //   ) {
  //     const url = `${BACKEND_URL}/getnoncompliantstoresbyaccount?manufacturer=${cookies.get(
  //       "manufacturer"
  //     )}&startDate=${cookies.get("startDate")}&endDate=${cookies.get(
  //       "endDate"
  //     )}&country=${cookies.get("country")}`;

  //     fetch(url, { method: "GET" })
  //       .then((res) => res.json())
  //       .then((result) => {
  //         result = result.filter(resultData => resultData.stores.length > 0);
  //         setData(result);
  //       })
  //       .catch((err) => console.log("------ Error ------", err));
  //   }
  // };

  useEffect(() => {
    // if (
    //   cookies.get("startDate") === undefined ||
    //   cookies.get("startDate") === "" ||
    //   cookies.get("startDate") === "undefined"
    // ) {
    //   let startDate = new Date();
    //   startDate.setMonth(startDate.getMonth() - 1);
    //   cookies.set("startDate", startDate);
    // }

    // if (
    //   cookies.get("endDate") === undefined ||
    //   cookies.get("endDate") === "" ||
    //   cookies.get("endDate") === "undefined"
    // ) {
    //   cookies.set("endDate", new Date());
    // }
    setTableConfigs(columns);
    // fetchBaseKpi();
  }, []);

  // useEffect(() => {
  //   setTableConfigs(columns);
  //   setData(auditData);
  // }, []);

  return (
    <div className="OverdueStoreAudits-wp">
      <ReportTableHeader
        title="No. of Non-Compliant Stores by Account"
        hideControlButtons={true}
      />
      <div className="separate-line" />
      <ReportTable
        columns={tableConfigs}
        dataSource={props.nonCompliant}
        isPagination={true}
      />
      <Modal
        title="No. of Non-Compliant Stores by Account"
        visible={visible}
        onCancel={() => setVisible(false)}
        onOk={() => setVisible(false)}
        footer={null}
      >
        <ReportTable
          columns={tableConfigs}
          dataSource={props.nonCompliant}
          isPagination={false}
        />
      </Modal>
      <div className="view-all-btn-wp">
        <ViewAllButton onClick={() => setVisible(true)} title="View all" />
      </div>
    </div>
  );
};

export default NoOfNonCompliantStoresByAccount;
